import React, { useState } from 'react';
import {MenuBookRounded, CategoryOutlined, } from '@mui/icons-material';
import Navbar from '../navsidebar/navbar';
import Sidebar from '../navsidebar/sidebar';

import Section from './settingsTabs/Sections';
import GridViewIcon from '@mui/icons-material/GridView';
import Category from './settingsTabs/Category';
import Items from './settingsTabs/Items';


const tabsData = [
    { icon: <GridViewIcon />, label: "Section Updation", content: <Section /> },
    { icon: <CategoryOutlined />, label: "Category Updation", content: <Category/> },
    // { icon: <GridViewIcon />, label: "SKU Mapping", content: <Sku/>},
    { icon: <MenuBookRounded />, label: "Items Updation", content: <Items/> },
  ];
  
  
const RetailSettings = () => {
    const [selectedTab, setSelectedTab] = useState(0);
  
    const handleTabSelect = (index) => {
      setSelectedTab(index);
    };
  
    return (
        <div className="flex h-screen">
        <Sidebar />
         <div className="flex flex-col w-full ">
         <Navbar />
          <div className="tabs-container flex-grow overflow-y-auto">
            <div className="tab-list">
              {tabsData.map((tab, index) => (
                <div
                  key={index}
                  className={`tab-item ${selectedTab === index ? 'selected' : ''}`}
                  onClick={() => handleTabSelect(index)}
                >
                  {tab.icon}
                  <span>{tab.label}</span>
                </div>
              ))}
            </div>
  
            <div className="tab-panels">
              {tabsData.map((tab, index) => (
                <div key={index} className={`tab-panel ${selectedTab === index ? 'selected' : ''}`}>
                  {selectedTab === index && (
                    <div>{tab.content}</div>
                  )}
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    );
  };
  
  export default  RetailSettings ;
  